import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAngleRight,
  faAngleDown,
  faExpand,
} from '@fortawesome/free-solid-svg-icons'
import { useLanguage } from '../contexts/LanguageContext'
import config from '../config/config'
import PhotoExif from './PhotoExif'
import PhotoAddToCart from './PhotoAddToCart'
import { getTranslatedLabel } from '../utils/getTranslations'

const Photo = ({ photo, isShortLine = true, canBuy = true }) => {
  const isShopEnabled = process.env.REACT_APP_TOGGLE_SHOP === 'true'
  const { t } = useTranslation()
  const { activeLanguage } = useLanguage()

  const [showDetails, setShowDetails] = useState(false)
  const [showFullScreen, setShowFullScreen] = useState(false)

  const toggleDetails = () => setShowDetails(!showDetails)
  const toggleFullScreen = () => setShowFullScreen(!showFullScreen)
  const isActionAvailable = photo.quality != 'MEDIUM' && canBuy

  return (
    <div className={`${canBuy ? 'photo-card' : ''} text-center`}>
      <div className="photo-frame">
        <img
          src={`${config.photoUrlMedium}${photo.id}.jpg`}
          alt={getTranslatedLabel(photo, activeLanguage)}
          className="photo-medium"
        />

        <p
          className="text-muted fst-italic"
          style={{ marginTop: '1.4rem', minHeight: '1.2em' }}
        >
          {getTranslatedLabel(photo, activeLanguage)}{' '}
        </p>
      </div>

      <div className="mt-2 d-flex justify-content-center flex-wrap gap-2">
        {isActionAvailable && (
          <button className="btn btn-primary btn-sm" onClick={toggleDetails}>
            {t('DETAILS')}{' '}
            <FontAwesomeIcon icon={showDetails ? faAngleDown : faAngleRight} />
          </button>
        )}
        {isShopEnabled && isActionAvailable && (
          <PhotoAddToCart photo={photo} t={t} />
        )}
        {isActionAvailable && photo.watermarkUuid && (
          <button
            className="btn btn-primary btn-sm"
            onClick={toggleFullScreen}
            title={t('EXPAND')}
          >
            <FontAwesomeIcon icon={faExpand} />
          </button>
        )}
      </div>

      {showDetails && (
        <div className="mt-3">
          <PhotoExif photo={photo} t={t} />
        </div>
      )}

      {photo.watermarkUuid && showFullScreen && (
        <div className="full-screen-overlay" onClick={toggleFullScreen}>
          <img
            src={`${config.photoUrlWatermark}${photo.watermarkUuid}.jpg`}
            alt={getTranslatedLabel(photo, activeLanguage)}
            className="full-screen-image"
          />
        </div>
      )}
    </div>
  )
}

export default Photo
